// src/components/NotFound.js
const NotFound = () => (
  <div className="text-center p-10 text-2xl text-gray-700">
    404 - Page Not Found
  </div>
);
export default NotFound;
